import type { ReactNode } from "react";

export interface LegendItem {
  key: string;
  label: string;
  /** O número, já formatado. A cor nunca vai sozinha: sempre rótulo e número. */
  value: string;
  share?: string;
  swatch: ReactNode;
}

/**
 * A legenda das barras do Resumo, em linha que quebra, como no protótipo: cor,
 * rótulo discreto, número em negrito e, se houver, a fatia.
 */
export function SummaryLegend({
  items,
  testIdPrefix,
}: {
  items: LegendItem[];
  testIdPrefix: string;
}) {
  return (
    <ul className="m-0 flex list-none flex-wrap gap-x-3 gap-y-0.5 p-0 text-[11.5px] text-[#5a6b84]">
      {items.map((item) => (
        <li
          key={item.key}
          data-testid={`${testIdPrefix}-${item.key}`}
          className="flex items-center gap-1.5"
        >
          {item.swatch}
          <span>{item.label}</span>
          <b className="font-semibold tabular-nums text-[#08254c]">{item.value}</b>
          {item.share && <span className="tabular-nums text-[#7b8799]">{item.share}</span>}
        </li>
      ))}
    </ul>
  );
}

/** Quadradinho de cor das barras, para a legenda. */
export function Swatch({ className }: { className: string }) {
  return <span aria-hidden className={`h-2 w-2 flex-none rounded-[2px] ${className}`} />;
}
